// extracted by mini-css-extract-plugin
module.exports = {"list":"PageControlV2_list__5pFMg","trigger":"PageControlV2_trigger__192cD","content":"PageControlV2_content__jGvOv"};